import { render, staticRenderFns } from "./entity-select.vue?vue&type=template&id=38b04324&scoped=true&"
import script from "./entity-select.ts?vue&type=script&lang=ts&"
export * from "./entity-select.ts?vue&type=script&lang=ts&"
import style0 from "./entity-select.scss?vue&type=style&index=0&id=38b04324&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b04324",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
